import { getFirestore, doc, setDoc, updateDoc, increment, serverTimestamp } from "firebase/firestore";
import { app } from "../firebase-config.js";

const db = getFirestore(app);

export const AnalyticsService = {
    /**
     * Log a view event for a series.
     * Upserts a daily stats document: `daily_stats/{YYYY-MM-DD}_{seriesId}`
     */
    logView: async (seriesId, authorId) => {
        if (!seriesId) return;

        try {
            // [SECURE] Call Cloud Function to increment View Count
            // [FIX] Explicitly specify region 'asia-northeast3' (Seoul) to match deployment
            const { getFunctions, httpsCallable } = await import("firebase/functions");
            const functions = getFunctions(app); // Reverted to default (us-central1) to match Server
            const logViewFn = httpsCallable(functions, 'logView');

            // Fire and forget (don't await result to block UI)
            logViewFn({ seriesId, authorId }).then(res => console.log("[Analytics] logView Success:", res.data))
                .catch(e => {
                    console.warn("[Analytics] Server logView failed:", e);
                });
            console.log(`[Analytics] Requested view log for ${seriesId}`);

            // console.log(`[Analytics] Requested view log for ${seriesId}`);
        } catch (e) {
            console.error("[Analytics] Failed to call logView:", e);
        }
    },

    /**
     * Log a view event by Hour for precise peak time analysis.
     * Collection: `analytics_hourly_views` -> Doc: `views_YYYY-MM-DD_HH_{seriesId}`
     */
    /**
     * Log a view event by Hour for precise peak time analysis.
     * [DEPRECATED] Handled by Cloud Function 'logView' (Phase 12 Audit Fix)
     * Direct Firestore write removed to enforce security.
     */
    logHourlyView: async (seriesId) => {
        // No-op: Hourly logging is now handled atomically by the server in 'logView'
        // console.log("[Analytics] logHourlyView is deprecated. Server handles it.");
    }
};
